import * as React from 'react'
import classnames from 'classnames'

interface NavItemProps {
	Icon: React.FC<{ active: boolean }>
	active: boolean
}

const NavItem: React.FC<React.PropsWithChildren<NavItemProps>> = ({ Icon, active, children }) => (
	<div
		className={classnames(
			'flex items-center relative gap-3 group font-medium cursor-pointer hover:text-white text-brand-gray-400 rounded-lg md:rounded-none py-2 px-4 md:h-14 hover:bg-brand-primary-md transition-colors',
			{
				'bg-brand-primary-md text-white': active,
			},
		)}
	>
		<div>
			<Icon active={active} />
		</div>
		<div className="text-[11px] hidden md:block">{children}</div>
		<span className="absolute md:hidden z-30 p-2 text-xs text-center text-brand-primary-md transition-all  scale-0 -translate-x-1/2 whitespace-nowrap bg-brand-primary-light rounded left-1/2 -bottom-6 group-hover:scale-100">
			<p>{children}</p>
		</span>
	</div>
)

export default NavItem
